<template>
  <div>
    <li class="tw-w-full tw-px-4 tw-py-3 tw-border-gray-200 tw-rounded-t-lg dark:tw-border-gray-600" :class="{ 'tw-border-b': showBottomBorder }">
      <slot />
    </li>
  </div>
</template>
<script>
export default {
  props: {
    showBottomBorder: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
